// Collection.js
// -----------------------
// @module Case
define("Katoomi.Shiphawk.Checkout.Collection", ["Backbone", "Katoomi.Shiphawk.Checkout.SS2Model", "Utils"], function(
    Backbone,
    CheckoutSS2Model,
    Utils
) {
    "use strict";
    return Backbone.Collection.extend({
        
        url: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/Checkout/SuiteScript2/Checkout.Service.ss"
            ),
            true
        ),
        model: CheckoutSS2Model,
        parse: function(response) {
            return response.rates;
        }
        
});
});
